// extracted by mini-css-extract-plugin
module.exports = {"container":"LiveIcon__container___1kVTH","anim":"LiveIcon__anim___3MWiL"};